import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
  Tooltip,
} from "reactstrap";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as Excel from "exceljs";
/*import './App.css';*/
/*import { Multiselect } from 'multiselect-react-dropdown';
import { Dropdown } from 'semantic-ui-react'*/
import { Multiselect } from "multiselect-react-dropdown";

import MultiSelectReact from "multi-select-react";
/*import Multiselect from 'multiselect-dropdown-react';
 */ import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import MySelect from "../../../../shared/components/form/MySelect";
import eye from "../../../../images/eye.png";
import LoadingOverlay from 'react-loading-overlay';
import "./styles.css";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.png'
import InfoIcon from '../../../../images/information-circle.jpg'
import editIcon from '../../../../images/pencil-alt.png'

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
const options = [];
const optionsUser = [];
var bin_array = [];
var rfqCheckedAll = {};
var zone_arr = [];
var aisles_arr = [];
var racks_arr = [];
var racks_aisle = [];

var options2 = [];

const options1 = [];




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    

    this.state = {
      showPassword: false,
      isApproveDisabled: true,
      options2: [],
      options1: [],
      loadingGRNData: false,
      editModal: false,
       tooltipOpen: false,
      searchQuery: '',  // This will hold the search query
      selectedItems: {},
      approveLoading: false,
      rejectLoading: false,
      totalValue: null,
      totalQty: null,
      cycleCountCancelModal: false,
      itemID: "",
      itemCode: "",
      isRejectDisabled: true,
      isSubmitDisabled: true,
      selectedLocationsVal: "",
      location_list: [],
      SelectedBins: [],
      genloading: false,
      selectedOptionRadio: "",
      loadBinData: false,
      schemas: [],
      showFetchGRNData: false,
      showSubmit: false,
      successModal: false,
      loadingprintbtn: false,
      modalAssignUser: false,
      zoneDataVal: [],
      removeSelectedDate: false,
      modalCancel: false,
      isChecked: false,
      showFailedItem: false,
      showCheckedCount: false,
      checkedCount: 0,
      batch_id: "",
      isCheckedData: {},
      FailedItems: [],
      grnNumber: "",
      grnValues: "",
      grnLineValue: "",
      selectedOptions: "",
      failedMessage: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      messageModalCycle: false,
      modalReport: false,
      disabledSubmitBtn: false,
      modalfailedCycle: false,
      showDashboardData: true,
      showRack: false,
      showZone: false,
    showProcess:false,
    onSelectProcess:"",
      showAisle: false,
      showBinTable: false,
      modalfailed: false,
      checkedAll: false,
      rfqCheckedAll: {},
      rfqChecked: {},
      postsGRN: [],
      postsProduct: [],
      multiSelect: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsProduct: [],
      ErrorRowData: [],
      binData: [],
      options: [],
      newArrayData: [],
      newArrayData1: [],
      totalScanCount: "",
      selectedUser: {},
      showAssignButton: true,
      showPrintButton: false,
      showSubmitBtn: false,
      clearData: false,
      showSelectedBin: false,
      optionSelected: null,
      optionSelected1: null,
      optionSelected2: null,
      isdisableAssignBtn: true,
    isdisableBinAssignBtn: false,
      optionForBinAddressDropdown: [],
      showBinAddressDropdown: false,
      value: "0",
      selectedBinAddress: "",
      all_binaddress: [],
      dropdownInProgress: false,
      selectedData: [],
      containerOnKeyDown: false,
    loading_overlay: false,
    };
  }

  
  failedToggleCancelCycle = () => {
    this.setState({
      modalfailedCycle: false,
    });

    window.location.reload();
  }


  componentDidMount(){
    this.getLocationList();
  }

   
  toggleTooltip = (id) => {
    this.setState((prevState) => ({
      tooltipOpen: prevState.tooltipOpen === id ? null : id,
    }));
  };

 

  
    
  componentWillMount() {
   

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  

  accessCookie =(cookieName) =>{
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie =(cname) =>{
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  messagetoggle = () => {
    this.setState({
      messageModal: true,
    });
  }



getLocationList = () => {
    
    const payload = {
      location: this.state.selectedLocation,
    };

  API.post('/cycle_count/fetchCCLocations', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
    
        this.setState({ location_list: data });
      })

      .then(async () => {
        
      });
}

submitBatch = () => {
    
    this.setState({
      approveLoading: true
    })
    
   
    const payload = {
      
      batch: this.state.batch_id,
      "approved": 1,
      approved_tasks: [],
      rejected_tasks: []
    };
    addAnalytics('CC Approval', 'CC Approve Batch', payload);

  API.post('/cycle_count/update-CCApproval/v2', { param: payload })

      .then((response) => response.data)

      .then((data) => {
    
        if(data.status == true){
          this.setState({
            success_message: data.reason,
            approveLoading: false,
            editModal: false
          })
         this.successToggle();


        }else{
          this.setState({
            failedMessage: data.reason,
            approveLoading: false,
            editModal: false
          })
          this.failedToggle();
        }
      })

      .then(async () => {
        
      });
}

/*resetCheckboxes = () => {
    // Reset the selected checkboxes in the state
    const updatedSelectedData = this.state.selectedData.map(item => {
        // Set isChecked to false for all items after approval
        return { ...item, isChecked: false };
    });

    // Clear the selected items for the "Check All" functionality
    const updatedSelectedItems = { ...this.state.selectedItems };
    updatedSelectedItems[this.state.batch_id] = [];  // Unselect all items for this batch

    this.setState({
        selectedData: updatedSelectedData,
        selectedItems: updatedSelectedItems,
        showSubmit: false,  // Assuming you want to hide the submit button after approval
    });
};*/

  resetCheckboxes = () => {
    const updatedSelectedData = this.state.selectedData.map(item => {
      item.isChecked = false;  // Uncheck all individual checkboxes
      return item;
    });

    const updatedSelectedItems = { ...this.state.selectedItems };
    updatedSelectedItems[this.state.batch_id] = [];  // Uncheck the "Check All" checkbox for the specific batch

    this.setState({
      selectedData: updatedSelectedData,  // Uncheck all items
      selectedItems: updatedSelectedItems,  // Uncheck the "Check All" checkbox
      checkedCount: 0,  // Reset the checked count
      showCheckedCount: false,  // Hide checked count message
    });
  };


  approveBatch = (editType) => {
    this.setState({ approveLoading: true });

    let arr = [];

    if (editType === "edit_true") {
      arr.push(this.state.itemID);
    } else {
      for (let i = 0; i < this.state.selectedData.length; i++) {
        if (this.state.selectedData[i].isChecked) {
          arr.push(this.state.selectedData[i].id);
        }
      }
    }

    const payload = {
      batch: this.state.batch_id,
      approved: 0,
      approved_tasks: arr,
      rejected_tasks: [],
    };

    addAnalytics('CC Approval', 'CC Approve Batch', payload);

    API.post('/cycle_count/update-CCApproval/v2', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        if (data.status === true) {
          this.setState({
            success_message: data.success_approvals,
            approveLoading: false,
            editModal: false,
          });
          this.successToggle();

          // After approval, reset the checkboxes (uncheck all items)
          this.resetCheckboxes();
        } else {
          this.setState({
            failedMessage: data.reason,
            approveLoading: false,
            editModal: false,
          });
          this.failedToggle();
          this.resetCheckboxes();
        }
      })
      .catch((error) => {
        console.error('Approval failed', error);
        this.setState({ approveLoading: false });
      });
  };


  rejectBatch = (editType) => {

       this.setState({
        rejectLoading: true
      })
      
       var arr = [];
       if(editType == "edit_true"){
        arr.push(this.state.itemID)
        
      }else{
        
        for(var i = 0; i< this.state.selectedData.length ; i++){
          if(this.state.selectedData[i].isChecked == true){
            arr.push(this.state.selectedData[i].id)
          }

        }
      }
      
      const payload = {

        batch: this.state.batch_id,
        "approved": null,
        approved_tasks: [],
        rejected_tasks: arr
      };
      addAnalytics('CC Approval', 'CC Reject Batch', payload);

    API.post('/cycle_count/update-CCApproval/v2', { param: payload })

        .then((response) => response.data)

        .then((data) => {
      
          if(data.status == true){
            this.setState({
              success_message: data.reason,
              rejectLoading: false,
              editModal: false
            })
           this.successToggle();
           this.resetCheckboxes();

          }else{
            this.setState({
              failedMessage: data.reason,
              rejectLoading: false,
              editModal: false
            })
            this.failedToggle();
            this.resetCheckboxes();
          }
        })

        .then(async () => {
          
        });
  }


  successToggle = () => {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ successModal: !prevState.successModal }));

    //window.location.reload();
  }

   successToggleOK = () => {
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    window.location.reload();
    this.fetchCycleCountDashboard();
  }

  failedToggle = ()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ modalfailed: !prevState.modalfailed }));
  }

   editToggle = (status, batchId, itemCode, itemID) => {
    this.setState((prevState) => ({ editModal: !prevState.editModal, item_status: status, batch_id: batchId, itemCode: itemCode, itemID: itemID }));
  }


  changeLocation = (e) => {
    this.setState({
      locationNotSelected: false,
      selectedLocationsVal: e.target.value,
    });
  };


  fetchCycleCountDashboard = ()=> {
    this.setState({
      genloading: true
    })
    const payload = {
      location: this.state.selectedLocationsVal,
    };
    addAnalytics('CC Approval', 'CC Approval Search Filter', payload);

    API.post('/cycle_count/fetchCCApproval', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        console.log("svsdhgdhgdhgdhgd");

        console.log('approval data',data);
        
        console.log(data.total_value, data.total_qty);

        if(data.status === false){
          this.setState({
            failedMessage: data.reason
          })
          //this.failedToggle();
          //return false;
        }else{

        // if (err) throw err;
          let newData = data.map((item) => ({
            ...item,
            isChecked: true,
          }));

        this.setState({ postsProduct: newData , totalValue: data.total_value,
          totalQty: data.total_qty, batch_id: data.batch_id, excess_total_qty: data.excess_total_qty, excess_total_value: data.excess_total_value, short_total_qty: data.short_total_qty, short_total_value: data.short_total_value });

        console.log(this.state.postsProduct);
      }
      })

      .then(async () => {
        this.setState({
          
          //tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  
  assemblePostsProduct = () => {
    console.log("cvbn");

    console.log(this.state.postsProduct);

    let postsProduct = this.state.postsProduct.map((post) => {
      return {
      
        prod_code: post.finance_approval == true ? <span> <span style={{ color: 'red' }} href="#" id="TooltipExample" class="fa fa-info-circle"></span><span>{post.prod_code}</span><Tooltip placement="right" isOpen={this.state.tooltipOpen} target="TooltipExample" toggle={this.toggleTooltip}>
          Finance approval Pending
        </Tooltip></span>: <span> {post.prod_code} </span>,
        product_name: post.prod_name,
        mrp: post.mrp,
        value: post.value_diff,
        qty: post.display_qty,
        reason: post.reason,
        remarks: post.remarks,
        status: post.approved === 0 ? <span> Approval Pending </span> : post.approved === 1 ? <span> Approved </span> : <span> Approval Rejected </span>,


      };
    });

    this.setState({
      genloading: false
    })

    return postsProduct;
  };

  handleRadioChange = (value) => {
    this.setState({ status_change_val: value, item_status: value });
  };

  ConfirmEdit= ()=>{

    if(this.state.item_status == "Approved"){
      this.approveBatch("edit_true");
    }else{
      this.rejectBatch("edit_true");
    }


  }


  handleSearch = (e) => {
    const searchQuery = e.target.value;
    this.setState({ searchQuery });
     this.state.postsProduct.forEach((item) => {
      const filteredData = item.data.filter((insideItem) => {
        const query = searchQuery.toLowerCase();
        return (
          insideItem.prod_code.toLowerCase().includes(query) ||
          insideItem.prod_name.toLowerCase().includes(query) ||
          (insideItem.approved === 0 && 'Approval Pending'.toLowerCase().includes(query)) ||
          (insideItem.approved === 1 && 'Approved'.toLowerCase().includes(query)) ||
          (insideItem.approved === 2 && 'Approval Rejected'.toLowerCase().includes(query))
        );
      });
      console.log('Filtered Data for Batch:', item.batch_id, filteredData);
    });
  };

 handleCheckboxChange = (batchId, itemId, filteredData) => {
    this.setState(prevState => {
      const updatedPostsProduct = filteredData.map(postItem => {
            if (postItem.id === itemId) {
              postItem.isChecked = !postItem.isChecked; // Toggle the isChecked value
            }
            return postItem;
      });

      console.log("filteredData",filteredData);
      console.log("updatedPostsProduct", updatedPostsProduct)

      // Count the total number of checked items
      let checkedCount = 0;
     
        filteredData.forEach(dataItem => {
          if (dataItem.isChecked) {
            checkedCount++;
          }
        });

       var checkPendingData = filteredData.filter((dataItem) => dataItem.approved === 0);

       console.log('checkPendingData', checkPendingData)

        if(checkPendingData.length == 0){
          this.setState({
            showSubmit: true
          })
        }else{
          this.setState({
            showSubmit: false
          })
        }
    


      // Enable or disable approve/reject buttons based on whether any items are checked
      const isAnyChecked = checkedCount > 0;

      if (isAnyChecked) {
        this.setState({
          isApproveDisabled: false,
          isRejectDisabled: false,
          isSubmitDisabled: false,
        });
      } else {
        this.setState({
          isApproveDisabled: true,
          isRejectDisabled: true,
           isSubmitDisabled: true,
        });
      }

      // Log the updated state and count of checked items
      console.log("updatedPostsProduct", updatedPostsProduct);
      console.log("Checked items count:", checkedCount);
      console.log("Any item checked?", isAnyChecked);
      if(checkedCount>0){
        this.setState({
          showCheckedCount: true,
          checkedCount: checkedCount,
          batch_id: batchId,
          selectedData: updatedPostsProduct,
        })
      }else{
        this.setState({
          showCheckedCount: false,
          checkedCount: checkedCount
        })
      }

      // Return the updated postsProduct state
      /*return { postsProduct: updatedPostsProduct };*/
    });
  };


  handleCheckAll = (batchId, data, filteredData) => {
      const allChecked = filteredData.every(item => item.isChecked);  // Check if all items are already checked

      this.setState(prevState => {
        const updatedPostsProduct = filteredData.map(postItem => {
          postItem.isChecked = !allChecked;  // Set all items to the opposite of their current state
          return postItem;
        });

        // Count the total number of checked items
        let checkedCount = updatedPostsProduct.filter(dataItem => dataItem.isChecked).length;

        // Update the state with the new checked items count
        this.setState({
          selectedData: updatedPostsProduct,
          checkedCount: checkedCount,
          showCheckedCount: checkedCount > 0,
          batch_id: batchId,
        });

        const isAnyChecked = checkedCount > 0;

          if (isAnyChecked) {
            this.setState({
              isApproveDisabled: false,
              isRejectDisabled: false,
              isSubmitDisabled: false,
            });
          } else {
            this.setState({
              isApproveDisabled: true,
              isRejectDisabled: true,
               isSubmitDisabled: true,
            });
          }

         var checkPendingData = filteredData.filter((dataItem) => dataItem.approved === 0);

         console.log('checkPendingData', checkPendingData)

          if(checkPendingData.length == 0){
            this.setState({
              showSubmit: true
            })
          }else{
            this.setState({
              showSubmit: false
            })
          }

        // Update the "Check All" checkbox state based on the new checked count
        const updatedSelectedItems = { ...prevState.selectedItems };
        updatedSelectedItems[batchId] = checkedCount === filteredData.length ? filteredData.map(item => item.id) : [];

        // Enable or disable approve/reject buttons based on whether any items are checked
        this.setState({
          selectedItems: updatedSelectedItems,
          isApproveDisabled: checkedCount === 0,
          isRejectDisabled: checkedCount === 0,
        });
      });
  };

  

  
 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const {
      showPassword,
      newArrayData,
      newArrayData1,
      selectedUser,
      modalReport,
    } = this.state;
    const { modal, modalCancel, editModal } = this.state;
    const { modalAssignUser, modalAssignUserCycleCount } = this.state;
    const {
      messageModal,
      modalfailed,
      successModal,
      modalfailedCycle,
      messageModalCycle,
      cycleCountCancelModal,
    } = this.state;
    const uniqueZoneData1 = {};
    const uniqueZoneData = {};
    newArrayData.map((item) => {
      if (!uniqueZoneData[item.zone_id]) {
        uniqueZoneData[item.zone_id] = {
          zoneId: item.zone_no,
          zoneName: item.zone_code,
          id: item.zone_id,
          items: [],
        };
      }
      uniqueZoneData[item.zone_id].items.push(item);
    });

    newArrayData1.map((item) => {
      if (!uniqueZoneData1[item.zone_id]) {
        uniqueZoneData1[item.zone_id] = {
          zoneId: item.zone_id,
          zoneName: item.zone__zone_code,
          items: [],
        };
      }
      uniqueZoneData1[item.zone_id].items.push(item);
    });

  

    const selectedOptionsStyles = {
      color: "#3c763d",
      backgroundColor: "#dff0d8",
    };
    const optionsListStyles = {
      backgroundColor: "#dff0d8",
      color: "#3c763d",
    };

    return (
      <Col xl={12}>
    {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card style={{marginTop: 10}}>
           <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex" }}
                >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                  >
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30 }}
                  >
                    <button
                      color="primary"
                      className="btn-sm button_view"
                      style={{
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                        fontWeight: 'normal'
                      }}
                      id="button_enable"
                      onClick={this.fetchCycleCountDashboard}
                    >
                      {this.state.isloading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      <img 
                        src={eye} 
                        alt="Eye" 
                        style={{ marginRight: "7px", width: "18px", height: "18px" }} 
                      />
                      View Data
                    </button>
                  </ButtonToolbar>
                </div>
              </div>
            </form>
           <Overlay>
            <form className="form">
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                    <span className="filter_title">Filters</span>
                  </div>


              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title"> Select Location</span>
              <div style={{ position: 'relative' }}>
               <select
                    className="form-control"
                    style={{ fontSize: 13 }}
                    onChange={this.changeLocation}
                    // name="year"               
                  >
                    <option value="">Select Location</option>
                    {this.state.location_list &&
                      this.state.location_list.length > 0 &&
                      this.state.location_list.map((location_list) => {
                        return (
                          <option value={location_list.id}>
                            {" "}
                            {location_list.code}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>


             <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={this.fetchCycleCountDashboard}
                  >
                    {this.state.genloading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View 
                  </Button>
                  </ButtonToolbar>
                </div>
            </form>
          </Overlay>
         
           

          {this.state.showDashboardData && (
            <CardBody style={{ marginTop: 20, width: '98%' }}>
               
             <div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      backgroundColor: '#f0f0f0',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: 10,
                    }}
                  >
                     <img 
                        src={InfoIcon} 
                        alt="Info" 
                        style={{ marginRight: "4px", width: "21px", height: "21px" }} 
                      />
                  </div>
                  {(this.state.showCheckedCount == false && !this.state.showSubmit) &&
                  <span>No items were selected from the batch</span>
                  }

                  {(this.state.showCheckedCount == true && !this.state.showSubmit) &&
                  <span>{this.state.checkedCount} Item were selected from the Batch - {this.state.batch_id}, please select Action to proceed</span>
                  }

                   {this.state.showSubmit &&
                  <span> All the Pending Items were Actioned process is completed </span>
                  }
                </div>
             


                  {/*<Button id="button_approve_disabled"  style={{marginBottom: 0, color: 'green', backgroundColor: '#fff', paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold', marginRight: 8}}  onClick={(e) => this.approveBatch()}>  {this.state.approveLoading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )} Approve</Button>*/}

                  {!this.state.showSubmit && 
                  <div>
                  <Button
                  type="button"
                  id="button_approved"
                  disabled={this.state.isApproveDisabled}
                  style={{opacity: this.state.isApproveDisabled == true ? "0.5" : '2', cursor: this.state.isApproveDisabled == true ? 'not-allowed' : 'pointer'}}
                  onClick={(e) => this.approveBatch("edit_false")}
              >
                  Approve
              </Button>

                  <Button
                  type="button"
                  id="button_rejected"
                  disabled={this.state.isRejectDisabled}
                  style={{opacity: this.state.isRejectDisabled == true ? "0.5" : '2', cursor: this.state.isRejectDisabled == true ? 'not-allowed' : 'pointer'}}
                  onClick={(e) => this.rejectBatch("edit_false")}
              >
                  Reject
              </Button>
              </div>
               }
                 {this.state.showSubmit && 
                 <Button
                  type="button"
                  id="button_Submit"
                  disabled={this.state.isSubmitDisabled}
                   style={{opacity: this.state.isSubmitDisabled == true ? "0.5" : '2', cursor: this.state.isSubmitDisabled == true ? 'not-allowed' : 'pointer'}}
                  onClick={(e) => this.submitBatch()}
              >
                  Submit
              </Button>
            }
                  </div>
                  </CardBody>
                  )}

            {this.state.showDashboardData && (
              /*<CardBody style={{ marginTop: 20, padding: '0 15px' }}>*/
              <div style={{ width: '100%', marginTop: 20 }}>
          <Accordion style={{ width: "100%", maxWidth: "100%" }} id="accordian" allowZeroExpanded={true}>
            {this.state.postsProduct.map((item, itemIndex) => {
              // Filter data based on search query for prod_code, prod_name, and status
              const filteredData = item.data.filter((insideItem) => {
                const query = this.state.searchQuery.toLowerCase();
                return (
                  insideItem.prod_code.toLowerCase().includes(query) ||
                  insideItem.prod_name.toLowerCase().includes(query) ||
                  (insideItem.approved === 0 && 'Approval Pending'.toLowerCase().includes(query)) ||
                  (insideItem.approved === 1 && 'Approved'.toLowerCase().includes(query)) ||
                  (insideItem.approved === 2 && 'Approval Rejected'.toLowerCase().includes(query))
                );
              });

              // Check if any filteredData item has approved === 0
              //const hasPendingApproval = filteredData.some(insideItem => insideItem.approved === 0);

              // If any item has approved === 0, log display_submit as false
              /*if (hasPendingApproval) {
                console.log("hasPendingApproval", hasPendingApproval)
                console.log('display_submit: false');
              }*/

              return (
                <AccordionItem key={itemIndex}>
                  <AccordionItemHeading>
                    <AccordionItemButton style={{ backgroundColor: '#fff' }}>
                      <span style={{ fontWeight: 'bold' }}>
                        Batch- {item.batch_id}
                      </span>&nbsp;&nbsp;&nbsp;&nbsp;
                      <span>{filteredData.length} items</span>
                      <span style={{ float: 'right' }}>
                        <b style={{ color: '#FBBB00' }}> Qty&nbsp;(pcs.)</b>&nbsp;&nbsp;
                        <b>Excess:</b> {item.excess_total_qty} &nbsp;&nbsp;&nbsp;
                        <b>Short:</b> {item.short_total_qty} &nbsp;&nbsp;&nbsp;&nbsp;
                        <b style={{ color: '#FBBB00' }}> Value&nbsp;(Rs.)</b>&nbsp;&nbsp;
                        <b>Excess:</b> {item.excess_total_value} &nbsp;&nbsp;&nbsp;
                        <b>Short:</b> {item.short_total_value}
                      </span>
                    </AccordionItemButton>
                  </AccordionItemHeading>

                  <AccordionItemPanel>
                    <div className="dispatchData stock_check_data style_table" style={{ marginTop: 1 }}>
                      <div style={{ marginBottom: 10, display: 'none' }}>
                        <input
                          type="text"
                          placeholder="Search"
                          value={this.state.searchQuery}
                          onChange={this.handleSearch}
                          style={{ width: '30%', padding: '8px' }}
                        />
                      </div>

                      <div className="inbound_table">
                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                          <table className="table" id="table_styling" style={{ width: '100%' }}>
                            <thead style={{ borderBottom: '2px solid #ddd' }}>
                              <tr>
                                <th style={{ width: '5%', position: 'relative' }}>
                                 <input
                                    type="checkbox"
                                    style={{position: 'absolute', bottom: '1%'}}
                                    checked={this.state.selectedItems[item.batch_id] && this.state.selectedItems[item.batch_id].length === item.data.length}
                                    onChange={() => this.handleCheckAll(item.batch_id, item.data, filteredData)}
                                  />
                                </th>
                                <th>Prod Code</th>
                                <th>Prod Name</th>
                                <th>MRP</th>
                                <th>Value (Mrp)</th>
                                <th>Qty to Adjust</th>
                                <th>Reason from WH</th>
                                <th>Approver Remarks</th>
                                <th>Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {filteredData.map((insideItem, index) => (
                                <tr className="tr_border" style={{ backgroundColor: '#fff', marginBottom: '5px' }} key={index}>
                                  <td style={{ position: 'relative', verticalAlign: 'top', paddingTop: '2px'}}>
                                    <div style={{ display: 'inline-block' }}>
                                    <input
                                      type="checkbox"
                                      checked={insideItem.isChecked}
                                      onChange={() => this.handleCheckboxChange(item.batch_id, insideItem.id, filteredData)}
                                    />
                                    </div>
                                  </td>
                                  <td>
                                    {insideItem.finance_approval ? (
                                      <span>
                                        <span
                                          style={{ color: 'red' }}
                                          href="#"
                                          id={`TooltipExample-${insideItem.id}`}
                                          className="fa fa-info-circle"
                                          onMouseEnter={() => this.toggleTooltip(insideItem.id)}
                                          onMouseLeave={() => this.toggleTooltip(null)}
                                        ></span>
                                        <span>{insideItem.prod_code}</span>
                                        <Tooltip
                                          placement="right"
                                          isOpen={this.state.tooltipOpen === insideItem.id}
                                          target={`TooltipExample-${insideItem.id}`}
                                          toggle={() => this.toggleTooltip(insideItem.id)}
                                        >
                                          Finance approval Pending
                                        </Tooltip>
                                      </span>
                                    ) : (
                                      <span>{insideItem.prod_code}</span>
                                    )}
                                  </td>
                                  <td>{insideItem.prod_name}</td>
                                  <td>{insideItem.mrp}</td>
                                  <td>{insideItem.value_diff}</td>
                                  <td>{insideItem.display_qty}</td>
                                  <td>{insideItem.reason}</td>
                                  <td>{insideItem.remarks}</td>
                                  <td>
                                    {insideItem.approved === 0 ? (
                                      <div className="pending_div"><span className="pending_text">Pending</span></div>
                                    ) : insideItem.approved === 1 ? (
                                      <div style={{ display: 'flex', alignItems: 'center' }}><div className="approved_div"><span className="approved_text">Approved</span></div><img src={editIcon} alt="edit" onClick={(e) => this.editToggle('Approved', item.batch_id, insideItem.prod_code,insideItem.id)} style={{width: 18,cursor: 'pointer', marginLeft: 6}}/></div>
                                    ) : (
                                      <div style={{ display: 'flex', alignItems: 'center' }}><div className="rejected_div"><span className="rejected_text">Rejected</span></div><img src={editIcon} alt="edit" onClick={(e) => this.editToggle('Rejected', item.batch_id, insideItem.prod_code, insideItem.id)} style={{ width: 18, marginLeft: '6px', cursor: 'pointer' }}/></div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>

      /*</CardBody>*/
          )}
      

        </Card>

       
        <Modal isOpen={successModal} toggle={this.successToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successToggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.toggle}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={cycleCountCancelModal} toggle={this.onCancelCycleModal}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancelCycleModal}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.onCancelCycleModal}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.editToggle}>
          <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            style={{ right: 15 }}
            onClick={this.messageToggleCycle}
          />
        </div>
        <div
          className="modal__body"
          style={{ paddingTop: 55, paddingBottom: 20, textAlign: 'center' }} // Center content inside modal
        >
          <span style={{ fontWeight: 'bold', fontSize: 16 }}> Edit Status - {this.state.batch_id} Batch </span>
          <br />
          <span style={{ fontSize: 15 }}> Item - {this.state.itemCode} </span>
          <div
            style={{
              marginTop: 20,
              display: 'flex',
              justifyContent: 'center', // This centers the radio buttons horizontally
              alignItems: 'center', // This vertically aligns the radio button and text
            }}
          >
            <div style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
              <label style={{ display: 'flex', alignItems: 'center' }}> {/* Ensure label is a flex container */}
                <input
                  type="radio"
                  name="status"
                  value="1"
                  checked={this.state.item_status === "Approved"}
                  onChange={() => this.handleRadioChange('Approved')}  // Approve selected
                  style={{ marginRight: 8 }}  // Removed marginTop here
                />
                <span
                  style={{
                    color: this.state.item_status === "Approved" ? 'green' : '',
                    fontSize: 15,

                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  Approve
                </span>
              </label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{ display: 'flex', alignItems: 'center' }}> {/* Ensure label is a flex container */}
                <input
                  type="radio"
                  name="status"
                  value="0"
                  checked={this.state.item_status === "Rejected"}
                  onChange={() => this.handleRadioChange('Rejected')}  // Reject selected
                  style={{ marginRight: 8 }} // Same here
                />
                <span
                  style={{
                    color: this.state.item_status === "Rejected" ? 'red' : '',
                    fontSize: 15,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  Reject
                </span>
              </label>
            </div>
          </div>
        </div>
        <ButtonToolbar className="modal__footer">
          <button
            style={{ marginRight: 8 }}
            className="modal_cancel"
            onClick={this.editToggle}
          >
            Cancel
          </button>
          <Button
            style={{ backgroundColor: "#24d6a3", color: "#fff" }}
            className="modal_ok"
            onClick={this.ConfirmEdit}
          >
            Confirm
          </Button>
        </ButtonToolbar>

        </Modal>

          

        <Modal isOpen={modalfailed} toggle={this.failedToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  className="modal_cancel"
              onClick={this.failedToggle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

       

        <Modal isOpen={modalfailedCycle} toggle={this.failedToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  className="modal_cancel"
              onClick={this.failedToggleCancelCycle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

      
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
